/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 *
 * Header custom del ShellStack — mismo layout que AppTabHeader, con back opcional y título.
 */
import React from 'react';
import { Platform, Pressable, StyleSheet, useWindowDimensions, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { Ionicons } from '@expo/vector-icons';
import { useNavigation } from '@react-navigation/native';
import type { NavigationProp, ParamListBase } from '@react-navigation/native';
import { AppOperationalHeaderBar } from './AppOperationalHeader';
import { navigateRoot } from './rootNavigation';
import { useTopChromeOffset } from './TopChromeOffsetContext';
import { ticketColors } from '../../shared/theme/ticketColors';
import { isWebSidebarLayout } from './shellScreenOptions';

type Props = {
  title: string;
  branchName?: string;
  showBack?: boolean;
  onBack?: () => void;
};

export function ShellOperationalHeader({
  title,
  branchName,
  showBack = false,
  onBack,
}: Props) {
  const navigation = useNavigation();
  const insets = useSafeAreaInsets();
  const { width } = useWindowDimensions();
  const { globalBannerHeight } = useTopChromeOffset();
  const topInset = Platform.OS === 'web' || globalBannerHeight > 0 ? 0 : insets.top;
  const showBranchChip = Boolean(branchName) && !isWebSidebarLayout(width);

  const leading =
    showBack && onBack ? (
      <Pressable
        onPress={onBack}
        accessibilityRole="button"
        accessibilityLabel="Volver"
        hitSlop={8}
        style={styles.backHit}
      >
        <Ionicons
          name={Platform.OS === 'ios' ? 'chevron-back' : 'arrow-back'}
          size={Platform.OS === 'ios' ? 28 : 24}
          color={ticketColors.ink}
        />
      </Pressable>
    ) : undefined;

  return (
    <View style={{ paddingTop: topInset }}>
      <AppOperationalHeaderBar
        title={title}
        {...(showBranchChip
          ? {
              branchName,
              onPressBranch: () =>
                navigateRoot(navigation as NavigationProp<ParamListBase>, 'BranchSelector'),
            }
          : {})}
        leading={leading}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  backHit: {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
